export const ROW_SPACING = 16;
export const ITEM_SIZE = 190 + ROW_SPACING;
export const DESKTOP_HEIGHT = 540;
export const MOBILE_HEIGHT = 910;
